import type React from 'react';

import { Outlet } from 'react-router-dom';

import { PermissionDeniedErrorPage } from '@platform/client/components/errors/permission-denied-error-page';

import { useHasSubscriptions } from '@apis/rendall/use-has-subscriptions';
import { useOrganizationParam } from '@packages/hooks/use-organization-param';

export type SubscriptionGuardProps = React.PropsWithChildren<{
  subscriptions: Parameters<typeof useHasSubscriptions>[1];
}>;

/**
 * NOTE: Review if you should use capabilities instead of subscriptions.
 * While subscriptions are helpful to hide features that are not useful/applicable to a customer,
 * capabilities should be used for the authorization of users to features.
 *
 * capability server capabilities guard: packages/components/src/capabilities/capabilities-guard/capabilities-guard.tsx
 * rendall capabilities guard: packages/components/src/capabilities/legacy-capabilities-guard/legacy-capabilities-guard.tsx
 *
 * @experimental For application using `@platform` only.
 */
export const SubscriptionsGuard = ({
  subscriptions,
  children,
}: SubscriptionGuardProps) => {
  const organizationId = useOrganizationParam();
  const hasSubscriptions = useHasSubscriptions(organizationId, subscriptions);

  return hasSubscriptions ? (
    children || <Outlet />
  ) : (
    <PermissionDeniedErrorPage />
  );
};
